import { Outlet } from "react-router-dom";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { PixelScripts } from "../integrations/pixels";

export function RootLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <PixelScripts />
      <Header />
      <main id="main-content" className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
